import { memo, type ReactElement } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

type Props = {
  id: number | string;
  message: string;
  expandComment?: (
    id: number | string,
    message: string,
    title?: string
  ) => void;
  dialog: {
    open: boolean;
    message?: string | JSX.Element | ReactElement[];
    id?: number;
  };
  title?: string;
  megaComent?: boolean;
  messageStyle?: React.CSSProperties;
};

function ExpandCommentCell({
  id,
  message,
  dialog,
  expandComment,
  title,
  megaComent = false,
  messageStyle
}: Props) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start'
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        <span
          style={
            megaComent
              ? {
                  wordBreak: 'break-all',
                  display: '-webkit-box',
                  WebkitLineClamp: '18',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  ...messageStyle
                }
              : {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  ...messageStyle
                }
          }
        >
          {message}
        </span>
      </div>

      <IconButton
        onClick={() => expandComment(id, message, title)}
        size="small"
        sx={{
          fontSize: '14px'
        }}
      >
        {dialog.open && dialog.id === id ? (
          <CloseFullscreenIcon fontSize="inherit" />
        ) : (
          <OpenInFullIcon fontSize="inherit" />
        )}
      </IconButton>
    </div>
  );
}

export default memo(ExpandCommentCell);
